<template>
  <nav class="navbar  navbar-expand-lg navbar-light mainbar">
  <div class="container-fluid ">
    <a class="navbar-brand" href="#">My portfolio</a>
   <center><button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button></center> 
    <div class="collapse navbar-collapse nav2" id="navbarNav">
      <ul class="navbar-nav ">
        <router-link to="/">
          <li class="nav-item ">
            <button class="btn btn-outline-light " style="border: none; border-radius:20px;"><i class=""></i> <span class="mx-2 container1" style="color:#AF1B3F;">Home</span> </button>
          </li>
        </router-link>
        
        <router-link to="/about">
          <li class="nav-item">
            <button class="btn btn-outline-light" style="border: none; border-radius:20px;"><i class=""></i> <span class="mx-2 container1">About</span></button>
          </li>
        </router-link>

        <router-link to="/projects">
          <li class="nav-item">
           <button class="btn btn-outline-light" style="border: none; border-radius:20px;"><i class=""></i> <span class="mx-2 container1">projects</span></button>
          </li>
       </router-link>
        
        <router-link to="/contact">
          <li class="nav-item">
            <button class="btn btn-outline-light" style="border: none; border-radius:20px;"><i class=""></i> <span class="mx-2 container1">Contact</span></button>
          </li>
        </router-link>

        
       <router-link to="/portfolio">
          <li class="nav-item">
           <button class="btn btn-outline-light" style="border: none; border-radius:20px;"><i class=""></i> <span class="mx-2 container1">Other</span></button>
          </li>
       </router-link> 
      </ul>
    </div>
  </div>
</nav>
</template>

<script>
export default {

}
</script>

<style>
.router-link {
  text-decoration: none;
}

.nav2 {
    margin-left: 400px;
}

.mainbar {
  background-color:#C4c4c477;
  z-index: 2000;
}

.container1 {
  color: black;
  font-weight: bold;
}

.container2 {
  background-color: #F79F1F;
}
</style>